module.exports = __webpack_public_path__ + "img/uk.d6cb25fb.png";